/* ==========================================================================================
   Commercial Equipment Online 2026 · ce-pages-b.js · the page templates (pages builder B, 10-10-2026)
   Loaded (deferred) by sections ce-main-page, ce-location-tail, ce-promo-page-*. Nothing here rewrites the store's
   words: it only adds ids, classes and wrappers to the page body so it reads well.
   1. Sticky offset: --cepb-hdr = how much of the sticky site header is on screen (it hides on the way down), so the
      "On this page" list and the help card never sit under it.
   2. Body tidy: empty spacer paragraphs out, tables scroll inside a box, IMPORTANT / CRUCIAL paragraphs become notice
      boxes, legal clauses that open with bold words are marked (the terms page has no headings), a heading that only
      holds a link ("SHOP NOW!") becomes the button it means to be.
   3. "On this page": built from the body's own headings (or the clause labels); the one being read is marked.
   4. FAQ accordion (snippets/ce-accordion-faq): native buttons (Enter / Space), aria-expanded, smooth height,
      find-in-page opens a closed answer (hidden="until-found"), a link to #<question id> opens it.
   5. The delivery map: the real delivery regions (assets/ce-home-map-dots.json) light up; the page's place is marked.
   6. Dates: [data-cepb-until="YYYYMMDD"] hides itself after that day, [data-cepb-after] shows itself.
   7. Copy a code ([data-cepb-copy]); the button carries .is-done while it says "Copied".
   8. The monthly voucher ([data-cev]): a light pass as it scrolls in, "Ends in N days" from its last day.
   9. The promotions board ([data-cepr]): "Shop the deals" tabs, card buttons, "Show more deals".
   Reduced motion: no smooth scroll, no height animation, the map is drawn still.
   ========================================================================================== */
(function () {
  'use strict';
  var W = window, D = document;
  if (W.CEPB) { return; }
  var reduce = W.matchMedia ? W.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var desk = W.matchMedia ? W.matchMedia('(min-width: 1100px)') : { matches: true, addEventListener: function () {} };
  var today = (function () { var d = new Date(); return d.getFullYear() * 10000 + (d.getMonth() + 1) * 100 + d.getDate(); })();
  var blank = function (el) { return !el.textContent.replace(/[\s ​]/g, ''); };
  var slug = function (t) { return t.toLowerCase().replace(/&/g, ' and ').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 56) || 'part'; };
  var each = function (root, sel, fn) { Array.prototype.forEach.call((root || D).querySelectorAll(sel), fn); };

  /* ---------- 1. sticky offset ---------- */
  var mains = [];
  var hdrMax = 0, lastHdr = -1, ticking = false;
  var setHdr = function () {
    ticking = false;
    var h = D.querySelector('.shopify-section.ce-hdr-section');
    var b = 0;
    if (h) { var r = h.getBoundingClientRect(); b = Math.max(0, Math.round(r.bottom)); if (r.top < 0 && b > hdrMax) hdrMax = b; }
    if (!hdrMax && h) hdrMax = Math.min(200, Math.round(h.getBoundingClientRect().height));
    if (b === lastHdr) return;
    lastHdr = b;
    mains.forEach(function (m) { m.style.setProperty('--cepb-hdr', b + 'px'); m.style.setProperty('--cepb-hdr-max', (hdrMax || 150) + 'px'); });
  };
  var onScroll = function () { if (!ticking) { ticking = true; W.requestAnimationFrame(setHdr); } };

  /* ---------- 2. body tidy ---------- */
  var MEDIA = 'img, iframe, video, svg, input, button, embed, object, table, form, select, textarea';
  var labelPrefix = function (p, re) {
    // wrap the leading words that match re (e.g. "IMPORTANT:") in a span, wherever they sit inside the paragraph
    var walker = D.createTreeWalker(p, NodeFilter.SHOW_TEXT, null), n;
    while ((n = walker.nextNode())) {
      if (!n.nodeValue.replace(/[\s *]/g, '')) continue;
      var m = re.exec(n.nodeValue);
      if (!m) return false;
      var start = n.nodeValue.indexOf(m[1]);
      var rest = n.splitText(start);
      var after = rest.splitText(m[1].length);
      var s = D.createElement('span'); s.className = 'cepb-callout__label';
      rest.parentNode.insertBefore(s, rest); s.appendChild(rest);
      return after;
    }
    return false;
  };
  var firstElem = function (p) {
    // the first element that holds text, looking through plain wrapper spans: <p><span><strong>Label</strong>...
    var n = p.firstChild;
    while (n && n.nodeType === 3 && !n.nodeValue.replace(/[\s ]/g, '')) n = n.nextSibling;
    if (!n || n.nodeType !== 1) return null;
    if (/^(STRONG|B)$/.test(n.tagName)) return n;
    if (n.tagName === 'SPAN') {
      var inner = firstElem(n);
      if (inner) return inner;
    }
    return null;
  };
  var tidy = function (body, light) {
    if (body.cepbTidy) return; body.cepbTidy = 1;
    each(body, 'p, h1, h2, h3, h4, h5, h6', function (el) {
      if (blank(el) && !el.querySelector(MEDIA)) el.remove();
    });
    each(body, 'table', function (t) {
      if (t.parentElement.classList.contains('cepb-table')) return;
      var w = D.createElement('div');
      w.className = 'cepb-table'; w.tabIndex = 0; w.setAttribute('role', 'region');
      w.setAttribute('aria-label', (t.caption && t.caption.textContent) || 'Table');
      t.parentNode.insertBefore(w, t); w.appendChild(t);
    });
    if (light) return;                                          // an FAQ answer: tidy only
    // IMPORTANT / CRUCIAL paragraphs (anywhere in the text, not inside a list, a table or an FAQ answer)
    Array.prototype.forEach.call(body.querySelectorAll('p'), function (p) {
      if (p.closest('li, td, th, .cepb-faq')) return;
      var txt = p.textContent.replace(/[\s ]+/g, ' ').trim();
      var alert = /^\**\s*(important|crucial)\b/i.test(txt);
      if (!alert) return;
      p.classList.add('cepb-callout');
      labelPrefix(p, /^[\s *]*((?:IMPORTANT|CRUCIAL|Important|Crucial)\s*:)/);
    });
    // a heading that only holds a link: the button it means to be ("SHOP NOW!")
    each(body, 'h1, h2, h3, h4', function (h) {
      var a = h.querySelector('a');
      if (!a || h.children.length !== 1 || h.textContent.trim() !== a.textContent.trim()) return;
      h.classList.add('cepb-cta-h'); a.classList.add('ce-btn');
    });
    // legal clauses that open with bold words; a first line that is the document's title
    var kids = Array.prototype.filter.call(body.children, function (k) { return k.tagName === 'P'; });
    kids.forEach(function (p, i) {
      if (p.classList.contains('cepb-callout')) return;
      var b = firstElem(p);
      if (!b) return;
      var label = b.textContent.replace(/[\s ]+/g, ' ').trim();
      var all = p.textContent.replace(/[\s ]+/g, ' ').trim();
      if (i === 0 && label === all && label.length < 90 && label === label.toUpperCase() && /[A-Z]/.test(label)) { p.classList.add('cepb-doc-title'); return; }
      if (label.length < 2 || label.length > 48) return;
      if (label === all && !/:$/.test(label)) return;          // a bold sentence on its own is not a clause
      p.classList.add('cepb-clause'); b.classList.add('cepb-clause__label');
      p.setAttribute('data-cepb-label', label.replace(/\s*:\s*$/, ''));
    });
  };

  /* ---------- 3. On this page ---------- */
  var tocs = [];
  var buildToc = function (main, body) {
    var nav = main.querySelector('[data-cepb-toc]');
    if (!nav) return;
    var min = +main.getAttribute('data-toc-min') || 3;
    var useLabels = main.getAttribute('data-toc-labels') === 'true';
    var skip = function (h) { return h.closest('.cepb-faq') || h.classList.contains('cepb-cta-h') || blank(h); };
    var pick = function (sel) { return Array.prototype.filter.call(body.querySelectorAll(sel), function (h) { return !skip(h); }); };
    var items = pick('h2, h3'), kind = 'h';
    if (items.length < min) { var low = pick('h4, h5'); if (low.length >= min) items = low; }
    if (items.length < min && useLabels) {
      // the clauses, with any real heading among them, in reading order (the terms page: clauses + "Privacy Policy")
      items = Array.prototype.filter.call(body.querySelectorAll('.cepb-clause[data-cepb-label], h2, h3'), function (h) { return h.classList.contains('cepb-clause') || !skip(h); });
      kind = 'label';
    }
    if (items.length < min) {
      nav.hidden = true;
      main.classList.remove('cepb-main--toc'); main.classList.add('cepb-main--plain');
      return;
    }
    var top = items.some(function (h) { return h.tagName === 'H2'; });
    var list = nav.querySelector('ol'), links = [], used = {};
    list.textContent = '';
    items.forEach(function (h) {
      var words = h.getAttribute('data-cepb-label') || h.textContent;
      if (!h.id) { var id = 'cepb-' + slug(words), k = id, i = 2; while (used[k] || D.getElementById(k)) k = id + '-' + i++; h.id = k; }
      used[h.id] = 1;
      var full = words.replace(/[\s ]+/g, ' ').replace(/\s*:\s*$/, '').trim();
      var li = D.createElement('li'), a = D.createElement('a');
      a.href = '#' + h.id; a.textContent = full;
      if (top && h.tagName === 'H3') li.className = 'is-sub';
      li.appendChild(a); list.appendChild(li); links.push(a);
    });
    var cnt = nav.querySelector('[data-cepb-toc-count]');
    if (cnt) cnt.textContent = '(' + links.length + ')';
    nav.hidden = false;
    var box = nav.querySelector('details');
    var fit = function () { if (box) box.open = desk.matches; };
    fit();
    if (desk.addEventListener) desk.addEventListener('change', fit);
    list.addEventListener('click', function (e) {
      var a = e.target.closest('a'); if (!a) return;
      var t = D.getElementById(a.getAttribute('href').slice(1)); if (!t) return;
      e.preventDefault();
      t.scrollIntoView({ behavior: reduce.matches ? 'auto' : 'smooth', block: 'start' });
      if (history.replaceState) history.replaceState(null, '', '#' + t.id);
      if (!desk.matches && box) box.open = false;
      t.setAttribute('tabindex', '-1'); t.focus({ preventScroll: true });
    });
    tocs.push({ links: links, items: items, nav: nav });
  };
  var markToc = function () {
    var line = Math.round(W.innerHeight * 0.28);
    tocs.forEach(function (t) {
      var cur = 0;
      for (var i = 0; i < t.items.length; i++) { if (t.items[i].getBoundingClientRect().top - line <= 0) cur = i; else break; }
      t.links.forEach(function (a, i) {
        if (i === cur) {
          if (a.getAttribute('aria-current') !== 'true') {
            a.setAttribute('aria-current', 'true');
            var box = t.nav.querySelector('.cepb-toc__box');
            if (box && desk.matches && box.scrollHeight > box.clientHeight) {
              var ar = a.getBoundingClientRect(), br = box.getBoundingClientRect();
              if (ar.top < br.top + 40 || ar.bottom > br.bottom - 40) box.scrollTop += (ar.top - br.top) - box.clientHeight / 2;
            }
          }
        } else if (a.hasAttribute('aria-current')) a.removeAttribute('aria-current');
      });
    });
  };
  var tocTick = false;
  var onScrollToc = function () { if (!tocTick) { tocTick = true; W.requestAnimationFrame(function () { tocTick = false; markToc(); }); } };

  /* ---------- 4. FAQ accordion ---------- */
  var setOpen = function (item, open, instant) {
    var q = item.querySelector('.cepb-faq__q'), a = item.querySelector('.cepb-faq__a');
    if (!q || !a) return;
    var was = q.getAttribute('aria-expanded') === 'true';
    if (was === open) return;
    q.setAttribute('aria-expanded', open ? 'true' : 'false');
    item.classList.toggle('is-open', open);
    var still = instant || reduce.matches || !a.animate;
    if (open) {
      a.hidden = false; a.removeAttribute('hidden');
      if (!still) { var h = a.scrollHeight; a.animate([{ height: '0px', opacity: 0 }, { height: h + 'px', opacity: 1 }], { duration: 320, easing: 'cubic-bezier(.22, 1, .36, 1)' }); }
    } else {
      var done = function () { a.setAttribute('hidden', 'until-found'); };
      if (still) { done(); return; }
      var h2 = a.scrollHeight;
      var an = a.animate([{ height: h2 + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 240, easing: 'cubic-bezier(.4, 0, .2, 1)' });
      an.onfinish = done;
    }
  };
  var syncAll = function (faq) {
    var all = faq && faq.querySelector('[data-cepb-faq-all]');
    if (!all) return;
    var items = faq.querySelectorAll('.cepb-faq__item');
    var allOpen = items.length && Array.prototype.every.call(items, function (it) { return it.classList.contains('is-open'); });
    all.setAttribute('aria-pressed', allOpen ? 'true' : 'false');
    all.classList.toggle('is-on', !!allOpen);
    var t = all.querySelector('span'); if (t) t.textContent = allOpen ? all.getAttribute('data-close') : all.getAttribute('data-open');
  };
  var initFaq = function (root) {
    each(root, '[data-cepb-faq]', function (faq) {
      if (faq.cepbFaq) return; faq.cepbFaq = 1;
      faq.addEventListener('click', function (e) {
        var q = e.target.closest('.cepb-faq__q'); if (!q || !faq.contains(q)) return;
        var item = q.closest('.cepb-faq__item');
        setOpen(item, q.getAttribute('aria-expanded') !== 'true');
      });
      each(faq, '.cepb-faq__a', function (a) {
        a.addEventListener('beforematch', function () { setOpen(a.closest('.cepb-faq__item'), true, true); syncAll(faq); });
      });
      // "Open all answers" / "Close all answers"
      var all = faq.querySelector('[data-cepb-faq-all]');
      if (all) {
        all.hidden = false;
        all.addEventListener('click', function () {
          var items = faq.querySelectorAll('.cepb-faq__item');
          var anyClosed = Array.prototype.some.call(items, function (it) { return !it.classList.contains('is-open'); });
          Array.prototype.forEach.call(items, function (it) { setOpen(it, anyClosed, true); });
          syncAll(faq);
        });
        faq.addEventListener('click', function (e) { if (e.target.closest('.cepb-faq__q')) setTimeout(function () { syncAll(faq); }, 0); });
        syncAll(faq);
      }
    });
    openFromHash();
  };
  var openFromHash = function () {
    var id = decodeURIComponent((location.hash || '').slice(1));
    if (!id) return;
    var el = D.getElementById(id);
    if (!el) return;
    var item = el.closest && el.closest('.cepb-faq__item');
    if (item) { setOpen(item, true, true); setTimeout(function () { item.scrollIntoView({ block: 'start' }); }, 30); }
  };

  /* ---------- 5. the delivery map ---------- */
  var NS = 'http://www.w3.org/2000/svg';
  var drawMap = function (fig) {
    if (fig.cepbMap) return; fig.cepbMap = 1;
    var url = fig.getAttribute('data-dots'); if (!url || !W.fetch) return;
    var place = (fig.getAttribute('data-place') || '').toLowerCase().trim();
    var alias = (fig.getAttribute('data-alias') || '').toLowerCase().trim();
    fetch(url, { credentials: 'omit' }).then(function (r) { return r.json(); }).then(function (data) {
      var g = fig.querySelector('[data-cepb-dots]'); if (!g || !data || !data.dots) return;
      var dots = data.dots.slice().sort(function (a, b) { return b.w - a.w; });
      var here = null;
      dots.forEach(function (d, i) {
        var n = (d.n || '').toLowerCase();
        if (!here && (n === place || (alias && n === alias))) here = d;
        var glow = D.createElementNS(NS, 'circle');
        glow.setAttribute('cx', d.x); glow.setAttribute('cy', d.y); glow.setAttribute('r', (5 + d.w * 2.2).toFixed(1));
        glow.setAttribute('class', 'cepb-map__glow');
        var dot = D.createElementNS(NS, 'circle');
        dot.setAttribute('cx', d.x); dot.setAttribute('cy', d.y); dot.setAttribute('r', (2.4 + d.w * 0.9).toFixed(1));
        dot.setAttribute('class', 'cepb-map__dot'); dot.style.setProperty('--d', Math.min(1400, i * 9));
        var t = D.createElementNS(NS, 'title'); t.textContent = d.n; dot.appendChild(t);
        g.appendChild(glow); g.appendChild(dot);
      });
      if (here) {
        var ring = D.createElementNS(NS, 'circle');
        ring.setAttribute('cx', here.x); ring.setAttribute('cy', here.y); ring.setAttribute('r', 11); ring.setAttribute('class', 'cepb-map__ring');
        var pin = D.createElementNS(NS, 'circle');
        pin.setAttribute('cx', here.x); pin.setAttribute('cy', here.y); pin.setAttribute('r', 11); pin.setAttribute('class', 'cepb-map__here');
        g.appendChild(ring); g.appendChild(pin);
        var lab = fig.querySelector('[data-cepb-map-label]');
        if (lab) {
          var x = here.x / 935 * 100, y = here.y / 847 * 100;
          lab.style.top = y + '%';
          if (x > 55) { lab.style.right = (100 - x + 2.6) + '%'; lab.style.left = 'auto'; } else { lab.style.left = (x + 2.6) + '%'; }
          lab.style.transform = 'translateY(-50%)';
          lab.hidden = false;
        }
      }
      fig.classList.add('is-lit');
    }).catch(function () {});
  };
  var initMaps = function (root) {
    var figs = (root || D).querySelectorAll('[data-cepb-map]');
    if (!figs.length) return;
    if (!('IntersectionObserver' in W)) { Array.prototype.forEach.call(figs, drawMap); return; }
    var io = new IntersectionObserver(function (ens) {
      ens.forEach(function (en) { if (en.isIntersecting) { io.unobserve(en.target); drawMap(en.target); } });
    }, { rootMargin: '200px 0px' });
    Array.prototype.forEach.call(figs, function (f) { io.observe(f); });
  };

  /* ---------- 6. dates, 7. copy ---------- */
  var initDates = function (root) {
    each(root, '[data-cepb-until]', function (el) { var u = +el.getAttribute('data-cepb-until'); if (u && u < today) el.classList.add('is-past'); });
    each(root, '[data-cepb-after]', function (el) { var u = +el.getAttribute('data-cepb-after'); if (u && u < today) el.hidden = false; });
  };
  var initCopy = function (root) {
    each(root, '[data-cepb-copy]', function (b) {
      if (b.cepbCopy) return; b.cepbCopy = 1;
      b.hidden = false;
      b.addEventListener('click', function () {
        var code = b.getAttribute('data-cepb-copy'), label = b.querySelector('[data-cepb-copy-label]');
        var ok = function () { if (!label) return; var was = label.textContent; label.textContent = b.getAttribute('data-done') || 'Copied'; b.classList.add('is-done'); setTimeout(function () { label.textContent = was; b.classList.remove('is-done'); }, 2200); };
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(ok, function () {});
      });
    });
  };

  /* 8. the monthly voucher (ce-promo-page-tiles, block "Voucher"): one light pass as it scrolls in (.is-in), and
     "Ends in N days" from its last day (data-cev-left="YYYYMMDD"; the day itself = "Last day today") */
  var initVoucher = function (root) {
    each(root, '[data-cev]', function (v) {
      if (v.cev) return; v.cev = 1;
      var left = v.querySelector('[data-cev-left]'), txt = left && left.querySelector('[data-cev-left-text]');
      if (left && txt) {
        var k = left.getAttribute('data-cev-left'), y = +k.slice(0, 4), m = +k.slice(4, 6), d = +k.slice(6, 8);
        var now = new Date(), t0 = new Date(now.getFullYear(), now.getMonth(), now.getDate()), end = new Date(y, m - 1, d);
        var days = Math.round((end - t0) / 864e5);
        if (y && days >= 0) {
          txt.textContent = days === 0 ? 'Last day today' : days === 1 ? 'Ends tomorrow' : 'Ends in ' + days + ' days';
          left.hidden = false;
        }
      }
      if (!('IntersectionObserver' in W)) { v.classList.add('is-in'); return; }
      var io = new IntersectionObserver(function (ens) {
        ens.forEach(function (en) { if (en.isIntersecting) { io.disconnect(); v.classList.add('is-in'); } });
      }, { threshold: .35 });
      io.observe(v);
    });
  };

  /* 9. the promotions board (sections/ce-promo-board, Tommy 10-10): "Shop the deals" tabs (arrow keys, Home, End move
     between them), a card's "Shop these deals" opens its tab and scrolls there, "Show more deals" shows the next ten, a
     link to #deals-<id> opens that tab. A tab or panel whose last day has passed (a page served from cache: 6. marks it
     .is-past) is taken out first. Without this every promotion's products simply follow one another. */
  var initBoard = function (root) {
    each(root, '[data-cepr]', function (bd) {
      if (bd.cepr) return; bd.cepr = 1;
      each(bd, '[data-cepr-tab].is-past, [data-cepr-panel].is-past', function (el) { el.parentNode.removeChild(el); });
      var bar = bd.querySelector('[data-cepr-tabs]');
      var tabs = bar ? Array.prototype.slice.call(bar.querySelectorAll('[data-cepr-tab]')) : [];
      var panels = Array.prototype.slice.call(bd.querySelectorAll('[data-cepr-panel]'));
      var idOf = function (el) { return el.getAttribute('data-cepr-tab') || el.getAttribute('data-cepr-panel'); };
      var show = function (id, focus) {
        tabs.forEach(function (t) { var on = idOf(t) === id; t.setAttribute('aria-selected', on ? 'true' : 'false'); t.tabIndex = on ? 0 : -1; if (on && focus) t.focus(); });
        panels.forEach(function (pn) { pn.hidden = idOf(pn) !== id; });
      };
      var tabbed = tabs.length > 1;
      if (tabbed) {
        bar.hidden = false;
        bd.classList.add('has-tabs');
        var m = /^#deals-(.+)$/.exec(W.location.hash || ''), first = idOf(tabs[0]);
        if (m && tabs.some(function (t) { return idOf(t) === m[1]; })) first = m[1];
        show(first);
        tabs.forEach(function (t, i) {
          t.addEventListener('click', function () { show(idOf(t)); });
          t.addEventListener('keydown', function (e) {
            var j = e.key === 'ArrowRight' ? (i + 1) % tabs.length : e.key === 'ArrowLeft' ? (i - 1 + tabs.length) % tabs.length : e.key === 'Home' ? 0 : e.key === 'End' ? tabs.length - 1 : -1;
            if (j >= 0) { e.preventDefault(); show(idOf(tabs[j]), true); }
          });
        });
      }
      each(bd, '[data-cepr-go]', function (a) {
        a.addEventListener('click', function (e) {
          var id = a.getAttribute('data-cepr-go'), pn = bd.querySelector('[data-cepr-panel="' + id + '"]');
          if (!pn) return;
          e.preventDefault();
          if (tabbed) show(id);
          (tabbed ? bar : pn).scrollIntoView({ behavior: reduce.matches ? 'auto' : 'smooth', block: 'start' });
          try { W.history.replaceState(null, '', '#deals-' + id); } catch (er) { /* file: or sandbox */ }
        });
      });
      each(bd, '[data-cepr-show]', function (b) {
        b.addEventListener('click', function () {
          var step = +b.getAttribute('data-cepr-show') || 10, pn = b.closest('[data-cepr-panel]');
          var hid = pn ? pn.querySelectorAll('li[data-cepr-more][hidden]') : [];
          for (var i = 0; i < hid.length && i < step; i++) hid[i].hidden = false;
          if (hid.length <= step) b.parentNode.hidden = true;
        });
      });
    });
  };

  var init = function (root) {
    root = root || D;
    each(root, '[data-cepb-main]', function (main) {
      if (main.cepbMain) return; main.cepbMain = 1;
      mains.push(main);
      each(main, '[data-cepb-prose]', function (b) { tidy(b, false); });
      each(main, '[data-cepb-answer]', function (b) { tidy(b, true); });
      var body = main.querySelector('[data-cepb-prose]');
      if (body) buildToc(main, body);
    });
    initFaq(root); initMaps(root); initDates(root); initCopy(root); initVoucher(root); initBoard(root);
    lastHdr = -1; setHdr(); markToc();
  };
  W.CEPB = { init: init };
  W.addEventListener('scroll', onScroll, { passive: true });
  W.addEventListener('scroll', onScrollToc, { passive: true });
  W.addEventListener('resize', function () { hdrMax = 0; onScroll(); onScrollToc(); });
  W.addEventListener('hashchange', openFromHash);
  D.addEventListener('shopify:section:load', function (e) { init(e.target); });
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', function () { init(D); }); else init(D);
})();
